/** Shared Prisma-style filter for active marketplace listings (Buy + seller listings). */
export const marketplaceBuyableWhere = {
  quantity: { gt: 0 },
  isActive: { equals: true },
  Pharmacy: {
    is: {
      PharmacyStatus: {
        is: {
          Status: {
            is: {
              key: { notIn: ["EXPIRED", "REJECTED", "PENDING"] },
            },
          },
        },
      },
    },
  },
};

/** Buy marketplace: active listings from other sellers only. */
export const marketplaceBuyWhereExcludingUser = (userId: number) => ({
  ...marketplaceBuyableWhere,
  // GraphQL IntFilter.not is NestedIntFilter — must be `{ equals }`, not a bare number
  userId: { not: { equals: userId } },
});
